import styled from 'styled-components';

import { BREAKPOINTS, FONT_FAMILIES } from 'common/styles/style-constants';

export const CarouselSection = styled.section`
  flex-grow: 1;
  position: relative;
  padding: 20px 0;
  background-color: transparent;
  overflow: hidden;

  @media (min-width: ${BREAKPOINTS.smallTabletMin}px) {
    padding: 60px 0;
  }

  @media (min-width: ${BREAKPOINTS.tabletMin}px) {
    height: ${(props) => props.height};
  }
`;

export const CarouselContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;

  && .ant-carousel {
    max-width: 70%;
    pointer-events: none;
  }
`;

export const CarouselWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  width: 730px;
  max-width: 100%;
  max-height: 100%;

  position: relative;
  padding: 0 15px;
`;

export const ReviewImg = styled.img`
  display: block;
  margin: 0 auto 20px;

  @media (max-width: ${BREAKPOINTS.mobileMax}px) {
    width: 80px;
    height: auto;
  }

  @media (max-width: ${BREAKPOINTS.mobileSmall}px) {
    display: none !important;
  }
`;

export const Review = styled.p`
  font-size: 16px;
  text-align: center;
  margin-bottom: 12px;

  @media (min-width: ${BREAKPOINTS.tabletMin}px) {
    font-size: 20px;
  }

  @media (max-width: ${BREAKPOINTS.mobileSmall}px) {
    font-size: 14px;
  }
`;

export const ReviewName = styled.p`
  font-family: ${FONT_FAMILIES.circular};
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 3px;
  text-align: center;
`;

export const ReviewTimestamp = styled.p`
  font-size: 14px;
  text-align: center;
`;

export const CarouselButton = styled.button`
  background: none;
  appearance: none;
  padding: 0;
  border: none;
  cursor: pointer;
  margin: 0 10px;

  & > * {
    font-size: 32px;
  }
`;
